import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import IcChevronRight from 'src/assets/images/icChevronRightBold.svg';
import { ItemLeftWrapper, ItemTitle, ThumbnailWrapper } from 'src/components/ItemInventory/ItemRow/common';
import ItemThumbnail from 'src/components/ItemInventory/ItemThumbnail';
import type { ItemDetail } from 'src/types/itemInventory';
import { languageDateLocaleMap } from 'src/utils/date';
import { getLocale } from 'src/utils/language';
const Common = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  cursor: pointer;
`;
const Thumbnail = styled(ThumbnailWrapper)`
  width: 40px;
  height: 40px;
`;
const ItemLabel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
const ItemDescription = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  color: ${({
  theme
}) => theme.color.content9};
`;
const ItemCardTitle = styled(ItemTitle)`
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  color: ${({
  theme
}) => theme.color.content12};
  ${({
  theme
}) => theme.screenSize.mobile} {
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
  }
`;
const ChevronIcon = styled(IcChevronRight)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: ${({
  theme
}) => theme.color.content6};
  ${({
  theme
}) => theme.isRtl && 'transform: scaleX(-1);'}
`;
interface Props extends Pick<ComponentProps<'div'>, 'onClick'> {
  item: ItemDetail;
}
const ItemCard: React.FC<Props> = ({
  item,
  ...props
}) => <Common {...props} data-sentry-element="Common" data-sentry-component="ItemCard" data-sentry-source-file="index.tsx">
    <ItemLeftWrapper data-sentry-element="ItemLeftWrapper" data-sentry-source-file="index.tsx">
      <Thumbnail data-sentry-element="Thumbnail" data-sentry-source-file="index.tsx">
        <ItemThumbnail item={item} data-sentry-element="ItemThumbnail" data-sentry-source-file="index.tsx" />
      </Thumbnail>
      <ItemLabel data-sentry-element="ItemLabel" data-sentry-source-file="index.tsx">
        <ItemCardTitle data-sentry-element="ItemCardTitle" data-sentry-source-file="index.tsx">{item.displayName}</ItemCardTitle>
        {!!item.dateValidUntil && <ItemDescription>
            {formatDistanceToNow(new Date(item.dateValidUntil), {
          locale: languageDateLocaleMap[getLocale()]
        })}
          </ItemDescription>}
      </ItemLabel>
    </ItemLeftWrapper>
    <ChevronIcon data-sentry-element="ChevronIcon" data-sentry-source-file="index.tsx" />
  </Common>;
export default ItemCard;